import { createSelector } from 'reselect';

import { RootState } from 'types/store';

const selectModals = (state: RootState) => state.modals;

const selectModalProps = createSelector(selectModals, (modals) => modals.modalProps);

export { selectModalProps, selectModals };
